import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppState } from "store";

export interface GlobalState {
  isWritingService: boolean;
  isRedirecting: boolean;
}

const initialState: GlobalState = {
  isWritingService: false,
  isRedirecting: false,
};

export const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setIsWritingService: (state, action: PayloadAction<boolean>) => {
      state.isWritingService = action.payload;
    },
    setIsRedirecting: (state, action: PayloadAction<boolean>) => {
      state.isRedirecting = action.payload;
    },
  },
});

export const { setIsWritingService, setIsRedirecting } = globalSlice.actions;

export const isWritingServiceSelector = ({ global }: AppState): boolean => global.isWritingService;

export const isRedirectionSelector = ({ global }: AppState): boolean => global.isRedirecting;

export default globalSlice.reducer;
